import React from 'react';
import styled from 'styled-components';
import { AiOutlineCaretDown } from 'react-icons/ai';

const StyledEmptyCell = styled.div`
  width: 100px;
  height: 47px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const EmptyCell = ({ onClick }) => {
  return (
    <StyledEmptyCell onClick={onClick}>
      <AiOutlineCaretDown style={{ height: '18px' }} />
    </StyledEmptyCell>
  );
};

export default EmptyCell;
